module.exports = {
        srcSet: __webpack_public_path__ + "static/media/charts-400.05b74372.webp"+" 400w",
        images: [{path: __webpack_public_path__ + "static/media/charts-400.05b74372.webp",width: 400,height: 400}],
        src: __webpack_public_path__ + "static/media/charts-400.05b74372.webp",
        toString: function(){return __webpack_public_path__ + "static/media/charts-400.05b74372.webp"},
        
        width: 400,
        height: 400
      }